import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { api, gbp, num } from "@/lib/api";
import { PageHeader, Pager } from "@/components/tam/ui";
import { Input } from "@/components/ui/input";

export default function Products() {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, page: 1, pages: 1 });

  useEffect(() => {
    const t = setTimeout(() => api.get("/products", { params: { q, page } }).then((r) => setData(r.data)), 300);
    return () => clearTimeout(t);
  }, [q, page]);

  return (
    <div data-testid="products-page">
      <PageHeader title="Products" subtitle="Every product line bought by lost & non-trading customers" />
      <div className="relative max-w-md mb-5">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} placeholder="Search code or description…" className="pl-9 bg-white" data-testid="products-search-input" />
      </div>
      <div className="bg-white border border-slate-200 rounded-md overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]" data-testid="products-table">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500 text-left">
            <tr><th className="px-4 py-3">Code</th><th className="px-4 py-3">Description</th><th className="px-4 py-3 text-right">Customers</th><th className="px-4 py-3 text-right">Qty</th><th className="px-4 py-3 text-right">Lost value</th></tr>
          </thead>
          <tbody>
            {data.items.map((p) => (
              <tr key={p.code} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`product-row-${p.code}`}>
                <td className="px-4 py-3 font-mono text-xs">{p.code}</td>
                <td className="px-4 py-3"><Link to={`/products/${encodeURIComponent(p.code)}`} className="font-medium hover:text-[#D9232A]" data-testid={`product-link-${p.code}`}>{p.description}</Link></td>
                <td className="px-4 py-3 text-right font-mono">{p.customers}</td>
                <td className="px-4 py-3 text-right font-mono">{num(p.total_qty)}</td>
                <td className="px-4 py-3 text-right font-mono">{gbp(p.total_value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pager page={data.page} pages={data.pages} total={data.total} onPage={setPage} />
    </div>
  );
}
